import React, { useMemo } from 'react';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import helpers from 'helpers';
import ExportableTable from 'containers/tables/ExportableTable';
import Pagination, { RowsPerPageDefault } from 'components/molecules/tables/components/Pagination';
import CellDiv from 'components/molecules/tables/components/CellDiv';
import { sum } from 'lodash';

const generateColumns = (totalSpend, totalImpressions, totalConversions) => [
    {
        Header: 'Zip Code',
        accessor: 'zipcode',
        style: {
            whiteSpace: 'unset',
            fontWeight: 'bold'
        },
        Footer: <CellDiv value='Total' strong />
    },
    {
        Header: 'City',
        accessor: 'city',
        style: { whiteSpace: 'unset' },
    },
    {
        Header: 'Conversions',
        accessor: 'conversions',
        style: { whiteSpace: 'unset' },
        Cell: row => <CellDiv value={row.value} type="number" />,
        Footer: <CellDiv value={totalConversions} type="number" strong />
    },
    {
        Header: 'Impressions',
        accessor: 'impressions',
        style: { whiteSpace: 'unset' },
        Cell: row => <CellDiv value={row.value} type="number" />,
        Footer: <CellDiv value={totalImpressions} type="number" strong />
    },
    {
        Header: 'Conversion Rate',
        accessor: 'conversion_rate',
        style: { whiteSpace: 'unset' },
        Cell: row => <CellDiv value={row.value} type="percentage" />,
        Footer: (
            <CellDiv value={helpers.safeDivide(totalConversions, totalImpressions)} type="percentage" strong />
        )
    },
    {
        Header: 'Budget',
        accessor: 'spend',
        style: { whiteSpace: 'unset' },
        Cell: row => <CellDiv value={row.value} type="price" />,
        Footer: <CellDiv value={totalSpend} type="price" strong />
    },
    {
        Header: 'CPM',
        accessor: 'cpm',
        style: { whiteSpace: 'unset' },
        Cell: row => <CellDiv value={row.value} type="price" />,
        Footer: <CellDiv value={helpers.safeDivide(totalSpend, helpers.safeDivide(totalImpressions, 1000))} type="price" strong />
    },
    {
        Header: 'CPA',
        accessor: 'cpa',
        style: { whiteSpace: 'unset' },
        Cell: row => <CellDiv value={row.value} type="price" />,
        Footer: <CellDiv value={helpers.safeDivide(totalSpend, totalConversions)} type="price" strong />
    },
    {
        Header: 'Top Site',
        accessor: 'top_site',
        style: { whiteSpace: 'unset' }
    },
    {
        Header: 'Top Device',
        accessor: 'top_device',
        style: { whiteSpace: 'unset' }
    },
    {
        Header: 'Population',
        accessor: 'population',
        style: { whiteSpace: 'unset' },
        Cell: row => <CellDiv value={row.value} type="number" />
    },
    {
        Header: 'Population Growth',
        accessor: 'population_growth',
        style: { whiteSpace: 'unset' },
        Cell: row => <CellDiv value={row.value / 100} type="percentage" />
    },
    {
        Header: 'Household Income',
        accessor: 'income',
        style: { whiteSpace: 'unset' },
        Cell: row => <CellDiv value={Math.round(row.value * 1000)} type="priceNoPrecision" />
    }
];

const title = 'ZIP CODE SUMMARY';
const exportName = 'lab-hyperlocal';

const HyperlocalTable = ({ data }) => {
    const columns = useMemo(() => {
        const totalSpend = sum(data.map(cell => cell.spend));
        const totalImpressions = sum(data.map(cell => cell.impressions));
        const totalConversions = sum(data.map(cell => cell.conversions));
        return generateColumns(totalSpend, totalImpressions, totalConversions);
    }, [data]);

    return (
        <ContentTile padding={helpers.contentPadding('table')}>
            <ContentHeader tableData={data} exportName={exportName} type={'table'}>{title}</ContentHeader>
            <ExportableTable
                key={1}
                title={title}
                exportName={exportName}
                data={data}
                columns={columns}
                defaultSorted={[{
                    id: 'zipcode'
                }]}
                showPagination={data.length > RowsPerPageDefault}
                PaginationComponent={Pagination}
                defaultPageSize={RowsPerPageDefault}
                minRows={data.length < RowsPerPageDefault ? data.length : RowsPerPageDefault}
                className="-highlight"
                getTfootProps={() => ({ style: { backgroundColor: '#E2E2E2', fontWeight: 'bold', boxShadow: 'none' } })}
            />
        </ContentTile>
    );
};

export default HyperlocalTable;



// WEBPACK FOOTER //
// ./src/components/molecules/tables/labs/HyperlocalTable.js